import useRenderOnlyClientSide from './useRenderOnlyClientSide';

/**
 * @example
 * let isQuoteButtonsEnabled = useIsQuoteButtonsEnabled()
 */
export function useIsQuoteButtonsEnabled() {
  let isQuoteButtonsEnabled = process.env.GATSBY_QUOTE_BUTTONS ? process.env.GATSBY_QUOTE_BUTTONS === 'true' : true;
  let render = useRenderOnlyClientSide();
  return isQuoteButtonsEnabled && render;
}
